import { IOrderFlexibleColumns } from '../../../../components/reusable/Table/types';
import { TFunction } from 'i18next';

export enum NOTIFICATION_CAMPAIGN_COLUMN_IDS {
  STATUS = 'status',
  KIND = 'kind',
  TEMPLATE_CODE = 'templateCode',
  SCHEDULED_AT = 'scheduledAt',
  LANGUAGE = 'language',
  ACTIONS = 'ACTIONS',
}

const defaultOrderBy = NOTIFICATION_CAMPAIGN_COLUMN_IDS.SCHEDULED_AT;

function columns(
  t: TFunction,
  includeActions: boolean,
): IOrderFlexibleColumns[] {
  const main: IOrderFlexibleColumns[] = [
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.STATUS,
      label: t('adminDashboard.notifications.campaigns.status'),
      key: NOTIFICATION_CAMPAIGN_COLUMN_IDS.STATUS,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_CAMPAIGN_COLUMN_IDS.STATUS,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.KIND,
      label: t('adminDashboard.notifications.campaigns.kindColumn'),
      key: NOTIFICATION_CAMPAIGN_COLUMN_IDS.KIND,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_CAMPAIGN_COLUMN_IDS.KIND,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.TEMPLATE_CODE,
      label: t('adminDashboard.notifications.campaigns.templateCode'),
      key: NOTIFICATION_CAMPAIGN_COLUMN_IDS.TEMPLATE_CODE,
      type: 'string',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_CAMPAIGN_COLUMN_IDS.TEMPLATE_CODE,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.SCHEDULED_AT,
      label: t('adminDashboard.notifications.campaigns.scheduledAt'),
      key: NOTIFICATION_CAMPAIGN_COLUMN_IDS.SCHEDULED_AT,
      type: 'date',
      sortable: true,
      draggable: false,
      sortingKey: NOTIFICATION_CAMPAIGN_COLUMN_IDS.SCHEDULED_AT,
      align: 'left',
      hided: false,
      canHide: false,
    },
    {
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.LANGUAGE,
      label: t('adminDashboard.notifications.campaigns.language'),
      key: NOTIFICATION_CAMPAIGN_COLUMN_IDS.LANGUAGE,
      type: 'string',
      sortable: false,
      draggable: false,
      sortingKey: NOTIFICATION_CAMPAIGN_COLUMN_IDS.LANGUAGE,
      align: 'left',
      hided: false,
      canHide: false,
    },
  ];
  if (includeActions) {
    main.push({
      id: NOTIFICATION_CAMPAIGN_COLUMN_IDS.ACTIONS,
      key: NOTIFICATION_CAMPAIGN_COLUMN_IDS.ACTIONS,
      label: '',
      type: 'string',
      sortable: false,
      sortingKey: NOTIFICATION_CAMPAIGN_COLUMN_IDS.ACTIONS,
      align: 'right',
      hided: false,
      isFixed: true,
      canHide: false,
    });
  }
  return main;
}

export default function getNotificationCampaignsTableColumns(
  t: TFunction,
  includeActions = true,
): IOrderFlexibleColumns[] {
  return columns(t, includeActions);
}

const hidedColumns: string[] = [];

export const getNotificationCampaignsDefaultSettings = (
  t: TFunction,
  includeActions = true,
) => ({
  columnsOrderIds: columns(t, includeActions)
    .filter((c) => !c.hided && !c.isFixed)
    .map((c) => c.id),
  orderBy: defaultOrderBy,
  order: 'desc',
  hidedColumns,
});
